const odia = {
  name: "Odia",
  native_name: "ଓଡିଆ",
  code: "od",
};

const od = {
  translation: {
    report_bug: "ବଗ୍ ରିପୋର୍ଟ କରନ୍ତୁ",
    import: "ଆମଦାନି",
    file: "ଫାଇଲ୍",
    new: "ନୂତନ",
    new_window: "ନୂତନ ୱିଣ୍ଡୋ",
    open: "ଖୋଲନ୍ତୁ",
    save: "ସେଭ୍",
    save_as: "ସେଭ୍ ଭାବରେ",
    save_as_template: "ଟେମ୍ପଲେଟ୍ ଭାବରେ ସେଭ୍ କରନ୍ତୁ",
    template_saved: "ଟେମ୍ପଲେଟ୍ ସେଭ୍ ହୋଇଗଲା",
    rename: "ନାମ ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
    delete_diagram: "ଡାୟାଗ୍ରାମ୍ ହଟାନ୍ତୁ",
    are_you_sure_delete_diagram: "ଆପଣ ନିଶ୍ଚିତ ଏହି ଡାୟାଗ୍ରାମ୍ ହଟାଇବେ? ",
    oops_smth_went_wrong: "ଉଫ୍! କିଛି ଭୁଲ୍ ହୋଇଗଲା।",
    import_diagram: "ଡାୟାଗ୍ରାମ୍ ଆମଦାନି କରନ୍ତୁ",
    import_from_source: "SQL ରୁ ଆମଦାନି କରନ୍ତୁ",
    export_as: "ରୂପେ ରପ୍ତାନି କରନ୍ତୁ",
    export_source: "SQL ରପ୍ତାନି କରନ୍ତୁ",
    models: "ମଡେଲ୍ସ",
    exit: "ବାହାରିବା",
    edit: "ସମ୍ପାଦନ କରନ୍ତୁ",
    undo: "ପୂର୍ବବତ୍ କରନ୍ତୁ",
    redo: "ପୁନରାବୃତ୍ତ କରନ୍ତୁ",
    clear: "ସଫା କରନ୍ତୁ",
    are_you_sure_clear:
      "ଆପଣ ନିଶ୍ଚିତ ଏହି ଡାୟାଗ୍ରାମ୍ ସଫା କରିବେ? ଏହା ଅପରିବର୍ତ୍ତନୀୟ ଅଟେ।",
    cut: "କଟ୍ କରନ୍ତୁ",
    copy: "କପି କରନ୍ତୁ",
    paste: "ପେଷ୍ଟ କରନ୍ତୁ",
    duplicate: "ନକଲ୍ କରନ୍ତୁ",
    delete: "ହଟାନ୍ତୁ",
    copy_as_image: "ଛବି ଭାବରେ କପି କରନ୍ତୁ",
    view: "ଦୃଶ୍ୟ",
    header: "ମେନୁବାର୍",
    sidebar: "ସାଇଡବାର୍",
    issues: "ସମସ୍ୟାଗୁଡିକ",
    presentation_mode: "ପ୍ରସ୍ତୁତି ମୋଡ୍",
    strict_mode: "ସ୍ତ୍ରିକ୍ଟ ମୋଡ୍",
    field_details: "ଫିଲ୍ଡ ବିବରଣୀ",
    reset_view: "ଦୃଶ୍ୟ ପୁନଃସେଟ୍ କରନ୍ତୁ",
    show_grid: "ଗ୍ରିଡ୍ ଦେଖାନ୍ତୁ",
    show_cardinality: "କାର୍ଡିନାଲିଟି ଦେଖାନ୍ତୁ",
    theme: "ଥିମ୍",
    light: "ଆଲୋକ",
    dark: "ଅନ୍ଧକାର",
    zoom_in: "ଜୁମ୍ ଇନ୍",
    zoom_out: "ଜୁମ୍ ଆଉଟ୍",
    fullscreen: "ପୂର୍ଣ୍ଣ ସ୍କ୍ରିନ୍",
    settings: "ସେଟିଂସ୍",
    show_timeline: "ଟାଇମଲାଇନ୍ ଦେଖାନ୍ତୁ",
    autosave: "ଅଟୋସେଭ୍",
    panning: "ପ୍ୟାନିଂ",
    table_width: "ଟେବଲ୍ ଚଉଡ଼ା",
    language: "ଭାଷା",
    flush_storage: "ସ୍ଟୋରେଜ୍ ସଫା କରନ୍ତୁ",
    are_you_sure_flush_storage:
      "ଆପଣ ନିଶ୍ଚିତ ସ୍ଟୋରେଜ୍ ସଫା କରିବେ? ଏହା ସମସ୍ତ ଆପଣଙ୍କର ଡାୟାଗ୍ରାମ୍ ଏବଂ କଷ୍ଟମ୍ ଟେମ୍ପଲେଟ୍ ଅପରିବର୍ତ୍ତନୀୟ ଭାବରେ ହଟାଇଦେବ।",
    storage_flushed: "ସ୍ଟୋରେଜ୍ ସଫା ହୋଇଗଲା",
    help: "ସାହାଯ୍ୟ",
    shortcuts: "ଶର୍ଟକଟ୍ସ",
    ask_on_discord: "ଆମକୁ Discord ରେ ପଚାରନ୍ତୁ",
    feedback: "ଫିଡବ୍ୟାକ୍",
    no_changes: "କୌଣସି ପରିବର୍ତ୍ତନ ନାହିଁ",
    loading: "ଲୋଡ୍ ହେଉଛି...",
    last_saved: "ଶେଷ ସେଭ୍",
    saving: "ସେଭ୍ ହେଉଛି...",
    failed_to_save: "ସେଭ୍ କରିବାରେ ବିଫଳ",
    fit_window_reset: "ୱିଣ୍ଡୋ ଫିଟ୍ କରନ୍ତୁ / ପୁନଃସେଟ୍ କରନ୍ତୁ",
    zoom: "ଜୁମ୍",
    add_table: "ଟେବଲ୍ ଯୋଡନ୍ତୁ",
    add_area: "ଅଞ୍ଚଳ ଯୋଡନ୍ତୁ",
    add_note: "ଟିପ୍ପଣୀ ଯୋଡନ୍ତୁ",
    add_type: "ପ୍ରକାର ଯୋଡନ୍ତୁ",
    to_do: "କରିବାକୁ",
    tables: "ଟେବଲ୍ସ",
    relationships: "ସମ୍ପର୍କ",
    subject_areas: "ବିଷୟ ଅଞ୍ଚଳଗୁଡିକ",
    notes: "ଟିପ୍ପଣୀଗୁଡିକ",
    types: "ପ୍ରକାରଗୁଡିକ",
    search: "ଖୋଜନ୍ତୁ...",
    no_tables: "କୌଣସି ଟେବଲ୍ ନାହିଁ",
    no_tables_text: "ଆପଣଙ୍କର ଡାୟାଗ୍ରାମ୍ ତିଆରି କରିବା ଆରମ୍ଭ କରନ୍ତୁ!",
    no_relationships: "କୌଣସି ସମ୍ପର୍କ ନାହିଁ",
    no_relationships_text:
      "ଫିଲ୍ଡଗୁଡିକୁ ଜୋଡିବାକୁ ଟାଣନ୍ତୁ ଏବଂ ସମ୍ପର୍କ ତିଆରି କରନ୍ତୁ!",
    no_subject_areas: "କୌଣସି ବିଷୟ ଅଞ୍ଚଳ ନାହିଁ",
    no_subject_areas_text: "ଗ୍ରୁପ୍ ଟେବଲ୍ଗୁଡିକୁ ବିଷୟ ଅଞ୍ଚଳ ଯୋଡନ୍ତୁ!",
    no_notes: "କୌଣସି ଟିପ୍ପଣୀ ନାହିଁ",
    no_notes_text: "ଅତିରିକ୍ତ ସୂଚନା ରେକର୍ଡ କରିବାକୁ ଟିପ୍ପଣୀଗୁଡିକୁ ବ୍ୟବହାର କରନ୍ତୁ",
    no_types: "କୌଣସି ପ୍ରକାର ନାହିଁ",
    no_types_text: "ଆପଣଙ୍କର ନିଜସ୍ୱ କଷ୍ଟମ୍ ଡାଟା ପ୍ରକାର ତିଆରି କରନ୍ତୁ",
    no_issues: "କୌଣସି ସମସ୍ୟା ମିଳିଲା ନାହିଁ।",
    strict_mode_is_on_no_issues:
      "ସ୍ତ୍ରିକ୍ଟ ମୋଡ୍ ବନ୍ଦ ଅଟେ ତେଣୁ କୌଣସି ସମସ୍ୟା ଦେଖାଯିବ ନାହିଁ।",
    name: "ନାମ",
    type: "ପ୍ରକାର",
    null: "Null",
    not_null: "ନଟ୍ null",
    primary: "ପ୍ରାଥମିକ",
    unique: "ଅନନ୍ୟ",
    autoincrement: "ସ୍ୱୟଂ ବୃଦ୍ଧି",
    default_value: "ଡିଫଲ୍ଟ",
    check: "ଚେକ୍ ଏକ୍ସପ୍ରେସନ୍",
    this_will_appear_as_is:
      "*ଏହା ଜେନେରେଟ୍ ସ୍କ୍ରିପ୍ଟରେ ଯେପରି ଅଛି ସେପରି ଦେଖାଯିବ।",
    comment: "ଟିପ୍ପଣୀ",
    add_field: "ଫିଲ୍ଡ ଯୋଡନ୍ତୁ",
    values: "ମୂଲ୍ୟଗୁଡିକ",
    size: "ଆକାର",
    precision: "ସଠିକତା",
    set_precision: "ସଠିକତା ସେଟ୍ କରନ୍ତୁ: (ଆକାର, ଡିଜିଟ୍ସ)",
    use_for_batch_input: "ବ୍ୟାଚ୍ ଇନପୁଟ୍ ପାଇଁ ବ୍ୟବହାର କରନ୍ତୁ",
    indices: "ଇଣ୍ଡାଇସେସ୍",
    add_index: "ଇଣ୍ଡେକ୍ସ ଯୋଡନ୍ତୁ",
    select_fields: "ଫିଲ୍ଡଗୁଡିକୁ ଚୟନ କରନ୍ତୁ",
    title: "ଶୀର୍ଷକ",
    not_set: "ସେଟ୍ ହୋଇନାହିଁ",
    foreign: "ଫରେନ୍",
    cardinality: "କାର୍ଡିନାଲିଟି",
    on_update: "ଅଦ୍ୟତନରେ",
    on_delete: "ହଟାଇବାରେ",
    swap: "ସ୍ୱାପ୍",
    one_to_one: "ଏକରୁ ଏକ",
    one_to_many: "ଏକରୁ ଅନେକ",
    many_to_one: "ଅନେକରୁ ଏକ",
    content: "ବିଷୟବସ୍ତୁ",
    types_info:
      "ଏହି ସୁବିଧା object-relational DBMS ଯେପରିକି PostgreSQL ପାଇଁ ଅଟେ।\nଯଦି MySQL କିମ୍ବା MariaDB ପାଇଁ ବ୍ୟବହାର କରାଯାଏ, ତେବେ ଏକ JSON ପ୍ରକାର ଜେନେରେଟ୍ ହେବ ଯାହାରେ ସମ୍ବନ୍ଧିତ json ବୈଧତା ଯାଞ୍ଚ ହେବ।\nଯଦି SQLite ପାଇଁ ବ୍ୟବହାର କରାଯାଏ ତେବେ ଏହାକୁ BLOB ରେ ପରିବର୍ତ୍ତନ କରାଯିବ।\nଯଦି MSSQL ପାଇଁ ବ୍ୟବହାର କରାଯାଏ ତେବେ ପ୍ରଥମ ଫିଲ୍ଡ ପାଇଁ ଏକ ପ୍ରକାର ଉପନାମ ଜେନେରେଟ୍ ହେବ।",
    table_deleted: "ଟେବଲ୍ ହଟାଇ ଦିଆଗଲା",
    area_deleted: "ଅଞ୍ଚଳ ହଟାଇ ଦିଆଗଲା",
    note_deleted: "ଟିପ୍ପଣୀ ହଟାଇ ଦିଆଗଲା",
    relationship_deleted: "ସମ୍ପର୍କ ହଟାଇ ଦିଆଗଲା",
    type_deleted: "ପ୍ରକାର ହଟାଇ ଦିଆଗଲା",
    cannot_connect: "କନେକ୍ଟ୍ କରିପାରିବେ ନାହିଁ, କଲମ୍ ପ୍ରକାର ଭିନ୍ନ ଅଟେ",
    copied_to_clipboard: "କ୍ଲିପ୍ବୋର୍ଡକୁ କପି ହୋଇଗଲା",
    create_new_diagram: "ନୂତନ ଡାୟାଗ୍ରାମ୍ ତିଆରି କରନ୍ତୁ",
    cancel: "ବାତିଲ୍ କରନ୍ତୁ",
    open_diagram: "ଡାୟାଗ୍ରାମ୍ ଖୋଲନ୍ତୁ",
    rename_diagram: "ଡାୟାଗ୍ରାମ୍ ନାମ ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
    export: "ରପ୍ତାନି",
    export_image: "ଛବି ରପ୍ତାନି",
    create: "ତିଆରି କରନ୍ତୁ",
    confirm: "ନିଶ୍ଚିତ କରନ୍ତୁ",
    last_modified: "ଶେଷ ସମୟରେ ସଂଶୋଧିତ",
    drag_and_drop_files:
      "ଫାଇଲ୍କୁ ଏଠାରେ ଟାଣନ୍ତୁ ଏବଂ ଛାଡନ୍ତୁ କିମ୍ବା ଅପଲୋଡ୍ କରିବାକୁ କ୍ଲିକ୍ କରନ୍ତୁ।",
    support_json_and_ddb: "JSON ଏବଂ DDB ଫାଇଲ୍ଗୁଡିକ ସମର୍ଥିତ",
    upload_sql_to_generate_diagrams:
      "ଆପଣଙ୍କର ଟେବଲ୍ ଏବଂ କଲମ୍ଗୁଡିକୁ ସ୍ୱୟଂଚାଳିତ ଭାବରେ ଜେନେରେଟ୍ କରିବାକୁ ଏକ sql ଫାଇଲ୍ ଅପଲୋଡ୍ କରନ୍ତୁ।",
    overwrite_existing_diagram: "ବର୍ତ୍ତମାନର ଡାୟାଗ୍ରାମ୍କୁ ଅଧିଲେଖନ କରନ୍ତୁ",
    only_mysql_supported:
      "*ବର୍ତ୍ତମାନ କେବଳ MySQL ସ୍କ୍ରିପ୍ଟଗୁଡିକୁ ଲୋଡ୍ କରିବା ସମର୍ଥିତ।",
    blank: "ଖାଲି",
    filename: "ଫାଇଲ୍ନାମ୍",
    table_w_no_name: "ନାମ ବିନା ଟେବଲ୍ ଘୋଷଣା କରାଯାଇଛି",
    duplicate_table_by_name: "ନାମ ଦ୍ୱାରା ନକଲ୍ ଟେବଲ୍ '{{tableName}}'",
    empty_field_name: "ଟେବଲ୍ '{{tableName}}' ରେ ଖାଲି ଫିଲ୍ଡ `ନାମ`",
    empty_field_type: "ଟେବଲ୍ '{{tableName}}' ରେ ଖାଲ",
    no_values_for_field:
      "ଟେବଲ '{{tableName}}' ର ଫିଲ୍ଡ '{{fieldName}}' ର ପ୍ରକାର `{{type}}` ଅଛି କିନ୍ତୁ କୌଣସି ମୂଲ୍ୟ ନିର୍ଦ୍ଦିଷ୍ଟ ହୋଇନାହିଁ",
    default_doesnt_match_type:
      "ଟେବଲ '{{tableName}}' ରେ ଫିଲ୍ଡ '{{fieldName}}' ର ଡିଫଲ୍ଟ ମୂଲ୍ୟ ତାହାର ପ୍ରକାର ସହିତ ମେଳ ଖାଉନାହିଁ",
    not_null_is_null:
      "ଟେବଲ '{{tableName}}' ର ଫିଲ୍ଡ '{{fieldName}}' ର ମୂଲ୍ୟ NOT NULL ଅଛି କିନ୍ତୁ ଡିଫଲ୍ଟ NULL ଅଛି",
    duplicate_fields:
      "ଟେବଲ '{{tableName}}' ରେ ନାମ '{{fieldName}}' ଥିବା ଡୁପ୍ଲିକେଟ ଟେବଲ ଫିଲ୍ଡସ୍",
    duplicate_index:
      "ଟେବଲ '{{tableName}}' ରେ ନାମ '{{indexName}}' ଥିବା ଡୁପ୍ଲିକେଟ ଇଣ୍ଡେକ୍ସ",
    empty_index:
      "ଟେବଲ '{{tableName}}' ରେ ଇଣ୍ଡେକ୍ସ କୌଣସି କଲମ୍ ଇଣ୍ଡେକ୍ସ କରୁନାହିଁ",
    no_primary_key: "ଟେବଲ '{{tableName}}' ରେ କୌଣସି ପ୍ରାଥମିକ କୁଞ୍ଜି ନାହିଁ",
    type_with_no_name: "କୌଣସି ନାମ ନଥିବା ପ୍ରକାରକୁ ଘୋଷଣା କରାଯାଇଛି",
    duplicate_types: "ନାମ '{{typeName}}' ଥିବା ଡୁପ୍ଲିକେଟ ପ୍ରକାର",
    type_w_no_fields:
      "କୌଣସି ଫିଲ୍ଡସ୍ ନଥିବା ପ୍ରକାର '{{typeName}}' କୁ ଘୋଷଣା କରାଯାଇଛି",
    empty_type_field_name: "ପ୍ରକାର '{{typeName}}' ରେ ଖାଲି ଫିଲ୍ଡ `ନାମ`",
    empty_type_field_type: "ପ୍ରକାର '{{typeName}}' ରେ ଖାଲି ଫିଲ୍ଡ `ପ୍ରକାର`",
    no_values_for_type_field:
      "ପ୍ରକାର '{{typeName}}' ର ଫିଲ୍ଡ '{{fieldName}}' ର ପ୍ରକାର `{{type}}` ଅଛି କିନ୍ତୁ କୌଣସି ମୂଲ୍ୟ ନିର୍ଦ୍ଦିଷ୍ଟ ହୋଇନାହିଁ",
    duplicate_type_fields:
      "ପ୍ରକାର '{{typeName}}' ରେ ନାମ '{{fieldName}}' ଥିବା ଡୁପ୍ଲିକେଟ ପ୍ରକାର ଫିଲ୍ଡସ୍",
    duplicate_reference: "ନାମ '{{refName}}' ଥିବା ଡୁପ୍ଲିକେଟ ସନ୍ଦର୍ଭ",
    circular_dependency: "ଟେବଲ '{{refName}}' ରେ ପରିପତ୍ର ନିର୍ଭରତା",
    timeline: "ସମୟରେଖା",
    priority: "ପ୍ରାଥମିକତା",
    none: "କିଛି ନାହିଁ",
    low: "ନିମ୍ନ",
    medium: "ମଧ୍ୟମ",
    high: "ଉଚ୍ଚ",
    sort_by: "ଦ୍ୱାରା କ୍ରମବଦ୍ଧ କରନ୍ତୁ",
    my_order: "ମୋର କ୍ରମ",
    completed: "ସମ୍ପୂର୍ଣ୍ଣ",
    alphabetically: "ବର୍ଣ୍ଣାନୁକ୍ରମରେ",
    add_task: "କାର୍ଯ୍ୟ ଯୋଡନ୍ତୁ",
    details: "ବିବରଣୀ",
    no_tasks: "ଆପଣଙ୍କ ପାଖରେ ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି କାର୍ଯ୍ୟ ନାହିଁ।",
    no_activity: "ଆପଣଙ୍କ ପାଖରେ ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି କାର୍ଯ୍ୟକଳାପ ନାହିଁ।",
    move_element: "{{name}} କୁ {{coords}} ରେ ନେଇଯାନ୍ତୁ",
    edit_area: "{{extra}} ଏଡିଟ୍ ଏରିଆ {{areaName}}",
    delete_area: "ଏରିଆ {{areaName}} କୁ ହଟାନ୍ତୁ",
    edit_note: "{{extra}} ନୋଟ୍ ଏଡିଟ୍ କରନ୍ତୁ {{noteTitle}}",
    delete_note: "ନୋଟ୍ {{noteTitle}} କୁ ହଟାନ୍ତୁ",
    edit_table: "{{extra}} ଟେବଲ ଏଡିଟ୍ କରନ୍ତୁ {{tableName}}",
    delete_table: "ଟେବଲ {{tableName}} କୁ ହଟାନ୍ତୁ",
    edit_type: "{{extra}} ପ୍ରକାର ଏଡିଟ୍ କରନ୍ତୁ {{typeName}}",
    delete_type: "ପ୍ରକାର {{typeName}} କୁ ହଟାନ୍ତୁ",
    add_relationship: "ସମ୍ପର୍କ ଯୋଡନ୍ତୁ",
    edit_relationship: "{{extra}} ସମ୍ପର୍କ ଏଡିଟ୍ କରନ୍ତୁ {{refName}}",
    delete_relationship: "ସମ୍ପର୍କ {{refName}} କୁ ହଟାନ୍ତୁ",
    not_found: "ମିଳିଲା ନାହିଁ",
  },
};

export { od, odia };
